import * as yup from "yup";

export const BranchSetupValidationSchema = yup.object().shape({
  branchTransitNo: yup
  .string()
  .required("Branch/Transit No. is required")
  .max(5, "Maximum length 5 characters"),
	bankId: yup
  .string()
  .required("bank No. is required"),
	branchAddress: yup
  .string()
  .required("Branch Address is required")
  .max(100, "Maximum length 100 characters"),
});
